import JSEncrypt from 'jsencrypt';

// RSA 公钥（固定公钥，也可以从接口获取）
const PUBLIC_KEY = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC7oHvvP3sjpTB61K5q6Uw/5mHi74NhnXbzJvpaCuzMEGnCd+BbT1NlnfLmEPf61ppf+9v5cmW2AAJ00y46yTkrcMD9s+ZOX153p+mfLIrI9nw0COnGF5F7Fc7+LU7SGtO03s7iLWeZspcCa+yEYVfd/df5lOtnTIhMVsFqlgHPRwIDAQAB`;

let encryptor = null;

/**
 * 获取加密器实例（单例模式）
 * @returns {JSEncrypt} 加密器实例
 */
function getEncryptor() {
  if (!encryptor) {
    encryptor = new JSEncrypt();
    encryptor.setPublicKey(PUBLIC_KEY);
  }
  return encryptor;
}

/**
 * 从接口获取公钥（可选）
 * @param {string} apiUrl 公钥接口地址，默认为 /admin/rsa/public-key
 * @returns {Promise<string>} 公钥字符串
 */
export async function fetchPublicKey(apiUrl = '/admin/rsa/public-key') {
  try {
    const response = await fetch(apiUrl);
    const result = await response.json();
    if (result.code === 200 && result.data) {
      return result.data;
    }
    return null;
  } catch (error) {
    console.error('获取公钥失败:', error);
    return null;
  }
}

/**
 * 设置公钥
 * @param {string} publicKey 公钥字符串
 */
export function setPublicKey(publicKey) {
  if (!encryptor) {
    encryptor = new JSEncrypt();
  }
  encryptor.setPublicKey(publicKey);
}

/**
 * RSA 加密密码
 * @param {string} password 明文密码
 * @returns {string|null} 加密后的密码（Base64编码），如果加密失败返回 null
 */
export function encryptPassword(password) {
  if (!password) {
    return password;
  }
  try {
    const encrypted = getEncryptor().encrypt(password);
    return encrypted;
  } catch (error) {
    console.error('密码加密失败:', error);
    return null;
  }
}

